export class UserPermissionTopicEnum {
  static USER_RIGHTS_SYSTEM: string;
  static ORGANIZATION: string;
  static LOCATION: string;
  static CONTACT: string;
  static PRODUCER: string;
  static USER: string;
  static ACCESS_RIGHTS: string;
  static WORK_GROUP: string;
  static CLASS: string;
  static FAVORITE: string;
  static DESIGNATION: string;
  static OBJECT: string;
  static FILE: string;
  static CHECKLIST: string;
  static JOB: string;
  static MESSAGE: string;
  static MODULE: string;
  static JOB_ROUTINE: string;
  static CONTRACT: string;
  static JOB_ROUTINE_TEMPLATE: string;
  static SERVICE_PROVIDER: string;
  static ADMINISTRATION: string;
  static INVOICE: string;
  static ADDRESS: string;
  static CHAT: string;
  static BATCH: string;
  static COMMUNITY: string;
  static MATERIAL: string;
  static SETTINGS: string;
  static TUEV: string;
  static FILTER: string;
  static CHECKLIST_TEMPLATE: string;
  static IMPORT: string;
  static AI_FEATURE: string;
  static MOBILE: string;
  static WORK_ORDER: string;
  static COMPONENT_CLASS_GROUP: string;

  static initialize(cacheData: { [key: string]: string }): void {
    this.USER_RIGHTS_SYSTEM = cacheData['USER_RIGHTS_SYSTEM'];
    this.ORGANIZATION = cacheData['ORGANIZATION'];
    this.LOCATION = cacheData['LOCATION'];
    this.CONTACT = cacheData['CONTACT'];
    this.PRODUCER = cacheData['PRODUCER'];
    this.USER = cacheData['USER'];
    this.ACCESS_RIGHTS = cacheData['ACCESS_RIGHTS'];
    this.WORK_GROUP = cacheData['WORK_GROUP'];
    this.CLASS = cacheData['CLASS'];
    this.FAVORITE = cacheData['FAVORITE'];
    this.DESIGNATION = cacheData['DESIGNATION'];
    this.OBJECT = cacheData['OBJECT'];
    this.FILE = cacheData['FILE'];
    this.CHECKLIST = cacheData['CHECKLIST'];
    this.JOB = cacheData['JOB'];
    this.MESSAGE = cacheData['MESSAGE'];
    this.MODULE = cacheData['MODULE'];
    this.JOB_ROUTINE = cacheData['JOB_ROUTINE'];
    this.CONTRACT = cacheData['CONTRACT'];
    this.JOB_ROUTINE_TEMPLATE = cacheData['JOB_ROUTINE_TEMPLATE'];
    this.SERVICE_PROVIDER = cacheData['SERVICE_PROVIDER'];
    this.ADMINISTRATION = cacheData['ADMINISTRATION'];
    this.INVOICE = cacheData['INVOICE'];
    this.ADDRESS = cacheData['ADDRESS'];
    this.CHAT = cacheData['CHAT'];
    this.BATCH = cacheData['BATCH'];
    this.COMMUNITY = cacheData['COMMUNITY'];
    this.MATERIAL = cacheData['MATERIAL'];
    this.SETTINGS = cacheData['SETTINGS'];
    this.TUEV = cacheData['TUEV'];
    this.FILTER = cacheData['FILTER'];
    this.CHECKLIST_TEMPLATE = cacheData['CHECKLIST_TEMPLATE'];
    this.IMPORT = cacheData['IMPORT'];
    this.AI_FEATURE = cacheData['AI_FEATURE'];
    this.MOBILE = cacheData['MOBILE'];
    this.WORK_ORDER = cacheData['WORK_ORDER'];
    this.COMPONENT_CLASS_GROUP = cacheData['COMPONENT_CLASS_GROUP'];
  }
}
